import React, { memo } from 'react';
import {
  FormPageInputItemSingleSelectionRadio,
  SingleSelectionRadioButtonHorizontalListInput,
  SingleSelectionRadioButtonListInputProps,
  SingleSelectionPropertyRadio,
} from 'shared';
import {
  SingleSelectionInputItemProps,
  SingleSelectionEvents,
  mapperRegistrationLimit,
} from './shared';
import { getRegistrationLimitHideOption } from './utils';

type Props = SingleSelectionInputItemProps<
  SingleSelectionPropertyRadio,
  FormPageInputItemSingleSelectionRadio
> & {
  value: FormPageInputItemSingleSelectionRadio['value'];
  subtexts: FormPageInputItemSingleSelectionRadio['subtexts'];
} & SingleSelectionEvents;

export const SingleSelectionRadioHorizontal: React.FC<Props> = memo(
  ({
    property,
    disabled,
    design,
    value,
    onSelectChange,
    onSubtextChange,
    onSubtextBlur,
    className,
    errorMessages,
    displayError,
    subtexts,
  }) => {
    const { propertyId, inputFormat, candidates, registrationLimit } = property;
    const handleChange = (value: number | null) => {
      onSelectChange(value ?? undefined);
    };
    const subtextsValue =
      subtexts?.map((subtext) => ({
        ...subtext,
        value: subtext.value ?? null,
      })) ?? [];
    const handleSubtextsChange: SingleSelectionRadioButtonListInputProps['onSubtextChange'] =
      (value, subtext) => {
        onSubtextChange(value, subtext);
      };
    const handleSubtextsBlur: SingleSelectionRadioButtonListInputProps['onSubtextBlur'] =
      (value, subtext) => {
        onSubtextBlur(value, subtext);
      };
    const candidatesExcludeUnselected = candidates
      .filter((candidate) => candidate.value != null)
      .map(mapperRegistrationLimit(registrationLimit?.limits));
    return (
      <SingleSelectionRadioButtonHorizontalListInput
        propertyId={propertyId}
        displayChoiceNumber={inputFormat.isNumbering}
        value={value ?? null}
        disabled={disabled}
        displayError={displayError}
        errorMessages={errorMessages}
        onSelectChange={handleChange}
        design={design}
        className={className}
        items={candidatesExcludeUnselected}
        subtexts={subtextsValue}
        showSelectItemImage={inputFormat.showCandidateImage}
        currentTime={registrationLimit?.currentTime}
        registrationLimitHideOption={getRegistrationLimitHideOption(
          registrationLimit?.labelDisplay,
        )}
        onSubtextChange={handleSubtextsChange}
        onSubtextBlur={handleSubtextsBlur}
      />
    );
  },
);
